var React = require('react');

function School (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#333333;}\n"),React.createElement("g",{"id":"XMLID_5_","key":1},React.createElement("path",{"id":"XMLID_9_","className":"st0","d":"M29.2,51.2v10.7L48,72.1l18.8-10.2V51.2L48,61.4L29.2,51.2z M48,23.9L18.5,40L48,56l24.1-13.2\n\t\tv18.5h5.4V40L48,23.9z"}))]);
}

School.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 96 96","style":{"enableBackground":"new 0 0 96 96"},"xmlSpace":"preserve"};

module.exports = School;

School.default = School;
